(function () {
  var initialCaptions = new WeakMap();
  var isApplying = false;
  var initTimer = null;
  var SKIO_DYNAMIC_BOX_PRODUCT_ID = '10640358441299';
  var SKIO_DYNAMIC_BOX_PRODUCT_ID_DAYS = '10712736858451';
  var LEGACY_BOX_2FL_SELLING_PLAN_ID = '691194724691';
  var LEGACY_BOX_1FL_SELLING_PLAN_ID = '691194659155';
  var MAX_BOX_TOTAL = 2;
  var MAX_BOX_ITEM = 2;
  var cachedDynamicBoxes = {};
  var cachedDynamicBoxPromises = {};
  var dynamicBoxCartIndex = 0;
  var isAddingToCart = false;
  var quantityTabsBound = false;
  var quantityTabFlBound = { '2': false, '3': false };
  var intervalUserChanged = false;
  var quantityTabUserChanged = false;
  var boundToggle = null;
  var toggleObserver = null;
  var boxSelectorBound = false;
  var legacyAtc1Bound = false;
  var legacyResizeBound = false;
  var RELEVANT_SELECTOR =
    '[data-60-days-2-fl], [data-one-flavour-box], [data-ol-1-fl], [data-ol-2-fl], [data-atc-1-fl], [data-atc-2-fl], [data-2-fl-container]';

  function withDomLock(fn) {
    isApplying = true;
    try {
      fn();
    } finally {
      isApplying = false;
    }
  }

  function scheduleInit() {
    if (initTimer) clearTimeout(initTimer);
    initTimer = setTimeout(function () {
      initTimer = null;
      init();
    }, 100);
  }

  function getElements() {
    return {
      toggle: document.querySelector('[data-60-days-2-fl]'),
      oneFlavourBox: document.querySelector('[data-one-flavour-box]'),
      ol1: document.querySelector('[data-ol-1-fl]'),
      ol2: document.querySelector('[data-ol-2-fl]'),
      atc1: document.querySelectorAll('[data-atc-1-fl]'),
      atc2: document.querySelectorAll('[data-atc-2-fl]'),
    };
  }

  function nodeIsRelevant(node) {
    if (!node || node.nodeType !== 1 || !node.matches) return false;
    if (node.matches(RELEVANT_SELECTOR)) return true;
    return !!node.querySelector(RELEVANT_SELECTOR);
  }

  function mutationIsRelevant(mutation) {
    if (mutation.type !== 'childList') return false;

    for (var i = 0; i < mutation.addedNodes.length; i += 1) {
      if (nodeIsRelevant(mutation.addedNodes[i])) return true;
    }

    return false;
  }

  function isExpanded(toggle) {
    if (!toggle) return false;
    if (toggle.getAttribute('aria-expanded') === 'true') return true;
    if (toggle.getAttribute('aria-expanded') === 'false') return false;

    var control = toggle.querySelector('[aria-expanded]');
    return control ? control.getAttribute('aria-expanded') === 'true' : false;
  }

  function getAtcClickTarget(el) {
    if (!el) return null;
    if (el.matches('button, a, input, [role="button"]')) return el;
    return el.querySelector('button, a, input, [role="button"]');
  }

  function setAtcDisabled(el, disabled) {
    if (!el) return;

    var clickTarget = getAtcClickTarget(el) || el;
    var isDisabled = clickTarget.getAttribute('aria-disabled') === 'true';

    if (isDisabled === disabled) return;

    if (clickTarget.matches('button, input')) {
      clickTarget.disabled = disabled;
    }

    clickTarget.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    clickTarget.style.pointerEvents = disabled ? 'none' : '';
    clickTarget.style.opacity = disabled ? '0.35' : '';
  }

  function setDisplay(nodes, value) {
    nodes.forEach(function (node) {
      if (node.style.display !== value) {
        node.style.display = value;
      }
    });
  }

  function getCaptionParagraph(atc2) {
    var caption = atc2.querySelector('[data-atc-caption]');
    if (!caption) return null;
    return caption.querySelector('p') || caption;
  }

  function rememberInitialCaptions(atc2Nodes) {
    atc2Nodes.forEach(function (atc2) {
      if (initialCaptions.has(atc2)) return;

      var captionEl = getCaptionParagraph(atc2);
      if (captionEl) {
        initialCaptions.set(atc2, captionEl.textContent.trim());
      }
    });
  }

  function getCaptionTextForBox(total, maxTotal, initialText) {
    if (total === 0) return initialText;
    if (total >= maxTotal) return 'Add to cart';
    if (total === maxTotal - 1) return 'pick one more flavour';
    return 'pick another 2 flavours';
  }

  function getCaptionText(total, initialText) {
    return getCaptionTextForBox(total, MAX_BOX_TOTAL, initialText);
  }

  function getFlPartSelector(flavorKey, part) {
    return '[data-' + part + '-' + flavorKey + '-fl]';
  }

  function getFlContainerSelector(flavorKey) {
    return '[data-' + flavorKey + '-fl-container]';
  }

  function getFlInputSelector(flavorKey) {
    return '[data-input-' + flavorKey + '-fl]';
  }

  function getContainerParts(container, flavorKey) {
    if (!flavorKey) {
      if (container.matches('[data-3-fl-container]') || container.matches('[data-input-3-fl]')) {
        flavorKey = '3';
      } else if (container.matches('[data-1-fl-container]') || container.matches('[data-input-1-fl]')) {
        flavorKey = '1';
      } else {
        flavorKey = '2';
      }
    }

    return {
      optionEl: container.querySelector(getFlPartSelector(flavorKey, 'option')),
      minus: container.querySelector(getFlPartSelector(flavorKey, 'minus')),
      quantity: container.querySelector(getFlPartSelector(flavorKey, 'quantity')),
      plus: container.querySelector(getFlPartSelector(flavorKey, 'plus')),
    };
  }

  function forEachFlContainers(root, flavorKey, fn) {
    if (!root) return;

    var containers = root.querySelectorAll(getFlContainerSelector(flavorKey));
    if (!containers.length) {
      containers = root.querySelectorAll(getFlInputSelector(flavorKey));
    }

    containers.forEach(fn);
  }

  function getQuantityDisplayEl(quantityEl) {
    if (!quantityEl) return null;
    if (quantityEl.matches('input, textarea, p, span')) return quantityEl;
    return quantityEl.querySelector('p') || quantityEl.querySelector('span') || quantityEl;
  }

  function readQuantity(quantityEl) {
    if (!quantityEl) return 0;

    var displayEl = getQuantityDisplayEl(quantityEl);

    if (displayEl.matches('input, textarea')) {
      var inputValue = parseInt(displayEl.value, 10);
      return isNaN(inputValue) ? 0 : inputValue;
    }

    var value = parseInt(displayEl.textContent, 10);
    return isNaN(value) ? 0 : value;
  }

  function writeQuantity(quantityEl, value) {
    if (!quantityEl) return;
    var next = String(value);
    var displayEl = getQuantityDisplayEl(quantityEl);

    if (displayEl.matches('input, textarea')) {
      if (displayEl.value !== next) {
        displayEl.value = next;
      }
      return;
    }

    if (displayEl.textContent.trim() !== next) {
      displayEl.textContent = next;
    }
  }

  function getTotalQuantity(root, flavorKey) {
    if (!root) return 0;
    flavorKey = flavorKey || '2';
    var total = 0;

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      total += readQuantity(parts.quantity);
    });

    return total;
  }

  function setButtonDisabled(button, disabled) {
    if (!button) return;

    var isDisabled = button.getAttribute('aria-disabled') === 'true';
    if (isDisabled === disabled) return;

    if (disabled) {
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.35';
      button.style.cursor = 'default';
    } else {
      button.style.removeProperty('pointer-events');
      button.style.removeProperty('opacity');
      button.style.removeProperty('cursor');
    }

    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function updateBoxControls(root, limits, flavorKey) {
    if (!root) return;
    flavorKey = flavorKey || '2';
    var maxTotal = limits && limits.maxTotal != null ? limits.maxTotal : 2;
    var maxItem = limits && limits.maxItem != null ? limits.maxItem : 2;
    var total = getTotalQuantity(root, flavorKey);

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      var qty = readQuantity(parts.quantity);

      setButtonDisabled(parts.minus, qty <= 0);
      setButtonDisabled(parts.plus, total >= maxTotal || qty >= maxItem);
    });
  }

  function parseShopifyGid(value) {
    if (value == null) return null;
    if (typeof value === 'number') return value;

    var match = String(value).match(/(\d+)$/);
    return match ? Number(match[1]) : Number(value);
  }

  function normalizeOption(value) {
    return String(value || '').trim().toLowerCase();
  }

  function findSkioVariantByOption(skioBox, option1Value) {
    var normalized = normalizeOption(option1Value);
    if (!normalized || !skioBox) return null;

    var variants = getSkioSelectableVariants(skioBox);
    var match = null;
    var i;

    for (i = 0; i < variants.length; i += 1) {
      if (normalizeOption(variants[i].productVariantTitle) === normalized) {
        return variants[i];
      }
    }

    for (i = 0; i < variants.length; i += 1) {
      var title = normalizeOption(variants[i].productVariantTitle);
      if (title.indexOf(normalized) !== -1 || normalized.indexOf(title) !== -1) {
        match = variants[i];
        break;
      }
    }

    return match;
  }

  function flattenDynamicSelectableVariants(skioBox) {
    if (!skioBox) return [];
    if (skioBox._flatVariants) return skioBox._flatVariants;

    var flat = [];
    var groups = skioBox.selectableProductVariants;

    if (Array.isArray(groups)) {
      groups.forEach(function (group) {
        if (!group) return;

        if (Array.isArray(group.productVariants)) {
          group.productVariants.forEach(function (variant) {
            if (variant) flat.push(variant);
          });
          return;
        }

        if (group.platformId && group.productVariantTitle) {
          flat.push(group);
        }
      });
    }

    skioBox._flatVariants = flat;
    return flat;
  }

  function getIntervalSelectElement() {
    return document.querySelector('select.subs-select[name="interval-select"]');
  }

  function getIntervalSelectUnit(select) {
    select = select || getIntervalSelectElement();
    if (!select || !select.options || !select.options.length) return null;

    var i;
    for (i = 0; i < select.options.length; i += 1) {
      var label = select.options[i].textContent.trim().toLowerCase();
      if (label.indexOf('day') !== -1) return 'days';
      if (label.indexOf('week') !== -1) return 'weeks';
    }

    return null;
  }

  function getActiveDynamicBoxProductId() {
    var unit = getIntervalSelectUnit();
    if (unit === 'days') {
      return SKIO_DYNAMIC_BOX_PRODUCT_ID_DAYS;
    }
    if (!unit && isLegacyDaysBoxPage()) {
      return SKIO_DYNAMIC_BOX_PRODUCT_ID_DAYS;
    }
    return SKIO_DYNAMIC_BOX_PRODUCT_ID;
  }

  function isLegacyDaysBoxPage() {
    if (document.querySelector('[data-quantity-tabs]')) return false;
    return !!(
      document.querySelector('[data-60-days-2-fl]') ||
      document.querySelector('[data-one-flavour-box]')
    );
  }

  function getSkioSelectableVariants(skioBox) {
    var source = skioBox || cachedDynamicBoxes[getActiveDynamicBoxProductId()];
    return flattenDynamicSelectableVariants(source);
  }

  function fetchSkioDynamicBoxConfig(productPlatformId) {
    var boxProductId = String(productPlatformId || getActiveDynamicBoxProductId());

    if (cachedDynamicBoxes[boxProductId]) {
      return Promise.resolve(cachedDynamicBoxes[boxProductId]);
    }

    if (cachedDynamicBoxPromises[boxProductId]) {
      return cachedDynamicBoxPromises[boxProductId];
    }

    cachedDynamicBoxPromises[boxProductId] = fetch(
      'https://api.skio.com/storefront-http/get-dynamic-box',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productPlatformId: boxProductId,
        }),
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var box = data.DynamicBox || data.dynamicBox;
        if (!data.ok || !box || !box.boxId) {
          throw new Error('Skio dynamic box config not found for product ' + boxProductId);
        }

        cachedDynamicBoxes[boxProductId] = box;
        flattenDynamicSelectableVariants(box);
        return box;
      })
      .finally(function () {
        delete cachedDynamicBoxPromises[boxProductId];
      });

    return cachedDynamicBoxPromises[boxProductId];
  }

  function maybePreloadDynamicBox() {
    fetchSkioDynamicBoxConfig().catch(function () {});
  }

  function formatSkioFlavorTitles(skioBox) {
    return getSkioSelectableVariants(skioBox)
      .map(function (variant) {
        return variant && variant.productVariantTitle;
      })
      .filter(Boolean)
      .join(', ');
  }

  function tabFlVariantMappingError(skioBox, flavorKey) {
    return (
      'Could not map flavor to variant id. Check data-option-' +
      flavorKey +
      '-fl values match Skio flavors: ' +
      formatSkioFlavorTitles(skioBox)
    );
  }

  function getReploProducts() {
    var jsonEl = document.getElementById('replo-deps-products');
    if (!jsonEl) return [];

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      // console.error('subs.js: failed to parse replo-deps-products', error);
      return [];
    }
  }

  function parseCartAddResponse(response) {
    return response.text().then(function (text) {
      var data = {};

      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error('Cart add invalid response: ' + text.slice(0, 300));
        }
      }

      if (!response.ok || data.status) {
        var details =
          data.description ||
          data.message ||
          (data.errors && JSON.stringify(data.errors)) ||
          JSON.stringify(data);

        throw new Error(details + ' (HTTP ' + response.status + ')');
      }

      return data;
    });
  }

  function cartAddUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart_add_url) {
      return window.theme.routes.cart_add_url;
    }

    return ((window.Shopify && window.Shopify.routes.root) || '/') + 'cart/add';
  }

  function cartAddJsonUrl() {
    var url = cartAddUrl();
    if (url.indexOf('/cart/add.js') !== -1) return url;
    return url.replace(/\/cart\/add\/?$/, '/cart/add.js');
  }

  function buildDynamicBoxCartPayload(lineItems, boxId, boxIndex, sellingPlanId) {
    var planId = parseShopifyGid(sellingPlanId) || sellingPlanId;

    return {
      items: lineItems.map(function (item) {
        return {
          id: Number(item.id),
          quantity: Number(item.quantity),
          selling_plan: planId,
          properties: {
            _dynamicBoxId: String(boxId),
            _dynamicBoxIndex: String(boxIndex != null ? boxIndex : 0),
          },
        };
      }),
    };
  }

  function buildOneTimeCartFormData(lineItems) {
    var formData = new FormData();
    if (!lineItems || !lineItems.length) return formData;

    if (lineItems.length === 1) {
      formData.append('id', String(lineItems[0].id));
      formData.append('quantity', String(lineItems[0].quantity));
      return formData;
    }

    lineItems.forEach(function (item, index) {
      formData.append('items[' + index + '][id]', String(item.id));
      formData.append('items[' + index + '][quantity]', String(item.quantity));
    });

    return formData;
  }

  function getSelectedFlavorLineItems(root, flavorKey, skioBox) {
    var totals = {};
    if (!root) return [];

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      if (!parts.optionEl) return;

      var option1Value = getOptionFlName(parts.optionEl, flavorKey);
      var variantId = getVariantIdByOption(option1Value, skioBox);
      var qty = readQuantity(parts.quantity);

      if (!variantId || qty <= 0) return;

      totals[variantId] = (totals[variantId] || 0) + qty;
    });

    return Object.keys(totals).map(function (id) {
      return { id: Number(id), quantity: totals[id] };
    });
  }

  function getOptionFlName(optionEl, flavorKey) {
    if (!optionEl) return '';
    flavorKey = flavorKey || '2';
    return (
      optionEl.getAttribute('data-option-' + flavorKey + '-fl') || optionEl.textContent || ''
    ).trim();
  }

  function refreshThemeCart(response, button) {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    document.dispatchEvent(
      new CustomEvent('theme:product:add', {
        bubbles: true,
        detail: {
          response: response,
          button: button,
        },
      })
    );
  }

  function getIntervalSelectSellingPlanId() {
    var select = getIntervalSelectElement();
    if (!select || !select.value) return null;
    return select.value;
  }

  function getDefaultIntervalValueForTab(tabKey, unit) {
    if (unit === 'days') {
      if (tabKey === '3') return 60;
      if (tabKey === '2') return 45;
      return 30;
    }

    if (tabKey === '3') return 12;
    if (tabKey === '2') return 8;
    return 4;
  }

  function selectIntervalByUnit(select, value, unit) {
    if (!select || !unit) return;

    var valueStr = String(value);
    var unitToken = unit === 'days' ? 'day' : 'week';
    var i;

    for (i = 0; i < select.options.length; i += 1) {
      var label = select.options[i].textContent.trim().toLowerCase();
      if (label.indexOf(valueStr) !== -1 && label.indexOf(unitToken) !== -1) {
        if (select.selectedIndex !== i) {
          select.selectedIndex = i;
        }
        return;
      }
    }
  }

  function syncIntervalForActiveTab() {
    if (intervalUserChanged) return;

    var select = getIntervalSelectElement();
    if (!select) return;

    var unit = getIntervalSelectUnit(select);
    if (!unit) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var tabKey = getActiveQuantityTabKey(quantityTabs) || '3';
    selectIntervalByUnit(select, getDefaultIntervalValueForTab(tabKey, unit), unit);
  }

  function applyDefaultQuantityTab() {
    if (quantityTabUserChanged) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    if (!quantityTabs) return;
    if (getActiveQuantityTabKey(quantityTabs) === '3') return;

    var tab3Inner = quantityTabs.querySelector('[data-tab-3-fl]');
    if (!tab3Inner) return;

    var tab3Button = tab3Inner.closest('[role="tab"]') || tab3Inner.closest('button');
    if (!tab3Button) return;

    tab3Button.click();
    requestAnimationFrame(syncIntervalForActiveTab);
  }

  function bindIntervalSelect() {
    var select = getIntervalSelectElement();
    if (!select) return;

    syncIntervalForActiveTab();

    if (select.dataset.subsIntervalBound) return;

    select.dataset.subsIntervalBound = 'true';
    select.addEventListener('change', function () {
      intervalUserChanged = true;
    });
  }

  var TAB1_FL_CONFIG = {
    key: '1',
    panelSelector: '[data-tab-cont-1-fl]',
    tabMarker: '[data-tab-1-fl]',
    atcSelector: '[data-atc-1-fl]',
  };

  function getTabConfigByKey(key) {
    if (key === '1') return TAB1_FL_CONFIG;
    return TAB_FL_CONFIGS[key] || null;
  }

  function getTab1PanelVariantId(panel) {
    if (!panel) return null;

    var tabPanel = panel.matches('[data-tab-cont-1-fl]')
      ? panel
      : panel.querySelector('[data-tab-cont-1-fl]');
    if (!tabPanel) return null;

    var raw = tabPanel.getAttribute('data-tab-cont-1-fl');
    if (!raw || raw === 'true' || raw === 'false') return null;

    return parseShopifyGid(raw);
  }

  function validateDynamicBoxSelection(skioBox, lineItems, config) {
    if (!skioBox || !lineItems || !lineItems.length) {
      throw new Error('No flavors selected for dynamic box.');
    }

    var total = 0;
    lineItems.forEach(function (item) {
      total += item.quantity;
    });

    if (config && config.maxTotal != null && total !== config.maxTotal) {
      throw new Error(
        'This box requires exactly ' + config.maxTotal + ' flavors (selected ' + total + ').'
      );
    }

    if (Array.isArray(skioBox.sizeRange) && skioBox.sizeRange.length >= 2) {
      var minSize = skioBox.sizeRange[0];
      var maxSize = skioBox.sizeRange[1];
      if (total < minSize || total > maxSize) {
        throw new Error(
          'This box requires between ' + minSize + ' and ' + maxSize + ' flavors (selected ' + total + ').'
        );
      }
    }

    lineItems.forEach(function (item) {
      if (!item.id) {
        throw new Error(tabFlVariantMappingError(skioBox, config ? config.key : '2'));
      }
    });
  }

  function getSubscriptionLineItemsForTab(tabKey, skioBox) {
    var config = getTabConfigByKey(tabKey);
    if (!config) return null;

    if (tabKey === '1') {
      var panel1 = document.querySelector(TAB1_FL_CONFIG.panelSelector);
      if (!panel1 || !isTabContFlActive(panel1, TAB1_FL_CONFIG)) return null;

      var variantId = getTab1PanelVariantId(panel1);
      if (!variantId) return null;

      return [{ id: variantId, quantity: 1 }];
    }

    var panel = getTabFlPanel(config);
    var root = panel ? getTabFlRoot(panel, config) : null;

    if (
      !panel ||
      !root ||
      !isTabContFlActive(panel, config) ||
      getTotalQuantity(root, config.key) < config.maxTotal
    ) {
      return null;
    }

    var lineItems = getSelectedFlavorLineItems(root, config.key, skioBox);
    if (!lineItems.length) return null;

    var totalUnits = 0;
    lineItems.forEach(function (item) {
      totalUnits += item.quantity;
    });

    if (totalUnits < config.maxTotal) return null;

    return lineItems;
  }

  function addDynamicBoxLineItemsToCart(button, lineItems, sellingPlanId, options) {
    options = options || {};
    if (isAddingToCart || !lineItems || !lineItems.length || !sellingPlanId) {
      return Promise.resolve();
    }

    isAddingToCart = true;
    var atcRoot = button;
    if (options.atcSelector) {
      atcRoot = button.closest(options.atcSelector) || button;
    }

    if (button) {
      button.classList.add('loading');
    }

    if (options.setAtcDisabledOnStart) {
      setAtcDisabled(atcRoot, true);
    }

    return fetchSkioDynamicBoxConfig(options.boxProductId)
      .then(function (skioBox) {
        validateDynamicBoxSelection(skioBox, lineItems, options.validationConfig);

        var boxIndex = dynamicBoxCartIndex;
        dynamicBoxCartIndex += 1;

        return fetch(cartAddJsonUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(
            buildDynamicBoxCartPayload(
              lineItems,
              skioBox.boxId,
              boxIndex,
              sellingPlanId
            )
          ),
        }).then(parseCartAddResponse);
      })
      .then(function (data) {
        if (data) {
          refreshThemeCart(data, button);
        }
      })
      .catch(function (error) {
        console.error(
          '[subs-dynamic.js] dynamic box add to cart failed',
          options.context || '',
          error
        );
      })
      .finally(function () {
        isAddingToCart = false;

        if (button) {
          button.classList.remove('loading');
        }

        if (typeof options.onFinally === 'function') {
          options.onFinally();
        }
      });
  }

  function addSubscriptionTabToCart(button, tabKey) {
    if (!tabKey) return Promise.resolve();

    var sellingPlanId = getIntervalSelectSellingPlanId();
    if (!sellingPlanId) return Promise.resolve();

    var config = getTabConfigByKey(tabKey);
    if (!config) return Promise.resolve();

    return fetchSkioDynamicBoxConfig().then(function (skioBox) {
      var lineItems = getSubscriptionLineItemsForTab(tabKey, skioBox);
      if (!lineItems || !lineItems.length) return Promise.resolve();

      return addDynamicBoxLineItemsToCart(button, lineItems, sellingPlanId, {
        atcSelector: config.atcSelector,
        setAtcDisabledOnStart: tabKey !== '1',
        validationConfig: config,
        context: 'tab ' + tabKey,
        onFinally: function () {
          if (tabKey !== '1') {
            updateTabFlAtcState(config);
          }
        },
      });
    });
  }

  function isOneTimeHeaderExpanded() {
    var oneHeader = document.querySelector('[data-one-header]');
    return !!(oneHeader && oneHeader.getAttribute('aria-expanded') === 'true');
  }

  function getOneTimeLineItemsForTab(tabKey) {
    var panel;
    var config;
    var root;

    if (tabKey === '1') {
      panel = document.querySelector(TAB1_FL_CONFIG.panelSelector);
      if (!panel || !isTabContFlActive(panel, TAB1_FL_CONFIG)) return null;

      var variantId = getTab1PanelVariantId(panel);
      if (!variantId) return null;

      return [{ id: variantId, quantity: 1 }];
    }

    config = getTabFlConfig(tabKey);
    panel = config ? getTabFlPanel(config) : null;
    root = panel ? getTabFlRoot(panel, config) : null;

    if (
      !config ||
      !panel ||
      !root ||
      !isTabContFlActive(panel, config) ||
      getTotalQuantity(root, config.key) < config.maxTotal
    ) {
      return null;
    }

    var lineItems = getSelectedFlavorLineItems(root, config.key, null);
    if (!lineItems.length) return null;

    var totalUnits = 0;
    lineItems.forEach(function (item) {
      totalUnits += item.quantity;
    });

    if (totalUnits < config.maxTotal) return null;

    return lineItems;
  }

  function addOneTimeToCart(button, tabKey) {
    if (isAddingToCart || !tabKey || !isOneTimeHeaderExpanded()) return Promise.resolve();

    var lineItems = getOneTimeLineItemsForTab(tabKey);
    if (!lineItems || !lineItems.length) return Promise.resolve();

    isAddingToCart = true;

    if (button) {
      button.classList.add('loading');
    }

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: buildOneTimeCartFormData(lineItems),
    })
      .then(parseCartAddResponse)
      .then(function (data) {
        if (data) {
          refreshThemeCart(data, button);
        }
      })
      .catch(function (error) {
        console.error('[subs.js] one-time add to cart failed (tab ' + tabKey + ')', error);
      })
      .finally(function () {
        isAddingToCart = false;

        if (button) {
          button.classList.remove('loading');
        }
      });
  }

  function getProductVariants() {
    var jsonEl = document.getElementById('replo-deps-template-product');
    if (!jsonEl) return [];

    try {
      var product = JSON.parse(jsonEl.textContent);
      return (product.data && product.data.variants) || product.variants || [];
    } catch (error) {
      // console.error('subs.js: failed to parse replo-deps-template-product', error);
      return [];
    }
  }

  function getAllReploVariants() {
    var variants = [];
    var seen = {};

    getReploProducts().forEach(function (entry) {
      if (!entry.data || !entry.data.variants) return;

      entry.data.variants.forEach(function (variant) {
        if (seen[variant.id]) return;
        seen[variant.id] = true;
        variants.push(variant);
      });
    });

    getProductVariants().forEach(function (variant) {
      if (seen[variant.id]) return;
      seen[variant.id] = true;
      variants.push(variant);
    });

    return variants;
  }

  function getVariantIdByOption(option1Value, skioBox) {
    if (!option1Value) return null;

    if (skioBox) {
      var skioMatch = findSkioVariantByOption(skioBox, option1Value);
      return skioMatch ? parseShopifyGid(skioMatch.platformId) : null;
    }

    var normalized = normalizeOption(option1Value);

    var skioVariant = getSkioSelectableVariants().find(function (variant) {
      return normalizeOption(variant.productVariantTitle) === normalized;
    });

    if (skioVariant) {
      return parseShopifyGid(skioVariant.platformId);
    }

    var variant = getAllReploVariants().find(function (entry) {
      return normalizeOption(entry.option1) === normalized;
    });

    return variant ? variant.id : null;
  }

  function hasQuantityTabs() {
    return !!document.querySelector('[data-quantity-tabs]');
  }

  function parseVariantIdFromOneFlavourAttr(raw) {
    if (!raw || raw === 'true' || raw === 'false') return null;
    return parseShopifyGid(raw);
  }

  function getExpandedOneFlavourBoxElement() {
    var nodes = document.querySelectorAll('[data-one-flavour-box]');
    var i;

    for (i = 0; i < nodes.length; i += 1) {
      if (isExpanded(nodes[i])) return nodes[i];
    }

    return null;
  }

  function getOneFlavourBoxScope(contextEl) {
    if (contextEl && contextEl.closest) {
      var fromAtc = contextEl.closest('[data-one-flavour-box]');
      if (fromAtc) return fromAtc;
    }

    var expanded = getExpandedOneFlavourBoxElement();
    if (expanded) return expanded;

    return document.querySelector('[data-one-flavour-box]');
  }

  function isOneFlavourBoxExpanded() {
    return !!getExpandedOneFlavourBoxElement();
  }

  function isLegacyOneFlavourBoxActive(atc1) {
    if (hasQuantityTabs() || !atc1) return false;
    if (isExpanded(getElements().toggle)) return false;
    return isOneFlavourBoxExpanded();
  }

  function getOneFlavourBoxVariantId(contextEl) {
    var scope = getOneFlavourBoxScope(contextEl);
    if (!scope) return null;

    var id = parseVariantIdFromOneFlavourAttr(scope.getAttribute('data-one-flavour-box'));
    if (id) return id;

    var markedNodes = scope.querySelectorAll('[data-one-flavour-box]');
    var i;
    for (i = 0; i < markedNodes.length; i += 1) {
      id = parseVariantIdFromOneFlavourAttr(
        markedNodes[i].getAttribute('data-one-flavour-box')
      );
      if (id) return id;
    }

    var ol1 = scope.querySelector('[data-ol-1-fl]');
    if (!ol1 && contextEl && contextEl.closest) {
      ol1 = contextEl.closest('[data-ol-1-fl]') || document.querySelector('[data-ol-1-fl]');
    }

    if (ol1) {
      var selected = ol1.querySelector('[role="option"][aria-selected="true"]');
      if (selected) {
        id = getVariantIdByOption(getOptionFlName(selected, '1'));
        if (id) return id;
      }
    }

    return null;
  }

  function bindLegacyAtc1Handler() {
    if (legacyAtc1Bound) return;
    legacyAtc1Bound = true;

    document.addEventListener(
      'click',
      function (event) {
        if (hasQuantityTabs()) return;

        var atc1 = event.target.closest('[data-atc-1-fl]');
        if (!atc1 || atc1.closest('[data-quantity-tabs]')) return;
        if (!isLegacyOneFlavourBoxActive(atc1)) return;

        var clickTarget = getAtcClickTarget(atc1) || atc1;
        if (
          clickTarget.getAttribute('aria-disabled') === 'true' ||
          clickTarget.disabled ||
          isAddingToCart
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return;
        }

        var variantId = getOneFlavourBoxVariantId(atc1);
        if (!variantId) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        addLegacy1FlDynamicBoxToCart(clickTarget);
      },
      true
    );
  }

  function updateAtc2SelectionState() {
    if (hasQuantityTabs()) return;

    var els = getElements();
    var ol2 = els.ol2;
    if (ol2 && ol2.closest('[data-quantity-tabs]')) return;

    var total = ol2 ? getTotalQuantity(ol2, '2') : 0;

    rememberInitialCaptions(els.atc2);

    els.atc2.forEach(function (atc2) {
      if (atc2.closest('[data-quantity-tabs]')) return;

      var captionEl = getCaptionParagraph(atc2);
      if (!captionEl) return;

      var initialText = initialCaptions.get(atc2) || captionEl.textContent.trim();
      var nextText = getCaptionText(total, initialText);

      if (captionEl.textContent !== nextText) {
        captionEl.textContent = nextText;
      }
    });

    if (!isExpanded(els.toggle)) return;

    els.atc2.forEach(function (atc2) {
      if (atc2.closest('[data-quantity-tabs]')) return;
      setAtcDisabled(atc2, total < MAX_BOX_TOTAL);
    });
  }

  function getLegacyFlavorListDisplay() {
    return window.innerWidth > 1439 ? 'flex' : 'grid';
  }

  function syncLegacyBoxToggle() {
    if (hasQuantityTabs()) return;

    withDomLock(function () {
      var els = getElements();
      var expanded = isExpanded(els.toggle);
      var visibleListDisplay = getLegacyFlavorListDisplay();

      if (els.ol1) {
        var ol1Display = expanded ? 'none' : visibleListDisplay;
        if (els.ol1.style.display !== ol1Display) {
          els.ol1.style.display = ol1Display;
        }
      }

      if (els.ol2) {
        var ol2Display = expanded ? visibleListDisplay : 'none';
        if (els.ol2.style.display !== ol2Display) {
          els.ol2.style.display = ol2Display;
        }
      }

      setDisplay(els.atc1, expanded ? 'none' : 'flex');

      if (expanded) {
        setDisplay(els.atc2, 'flex');
        if (els.ol2) {
          updateAtc2SelectionState();
        } else {
          els.atc2.forEach(function (atc2) {
            if (!atc2.closest('[data-quantity-tabs]')) {
              setAtcDisabled(atc2, true);
            }
          });
        }
      } else {
        setDisplay(els.atc2, 'none');
        els.atc1.forEach(function (atc1) {
          if (!atc1.closest('[data-quantity-tabs]')) {
            setAtcDisabled(atc1, false);
          }
        });
        els.atc2.forEach(function (atc2) {
          if (!atc2.closest('[data-quantity-tabs]')) {
            setAtcDisabled(atc2, false);
          }
        });
      }
    });
  }

  function bindLegacyBoxToggle(toggle) {
    if (!toggle || toggle === boundToggle) return;

    if (toggleObserver) toggleObserver.disconnect();

    boundToggle = toggle;
    toggleObserver = new MutationObserver(function () {
      if (!isApplying) syncLegacyBoxToggle();
    });
    toggleObserver.observe(toggle, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
      subtree: true,
    });
  }

  function changeLegacyBoxQuantity(container, delta) {
    if (hasQuantityTabs()) return;

    var ol2 = container.closest('[data-ol-2-fl]');
    if (!ol2 || ol2.closest('[data-quantity-tabs]')) return;

    var parts = getContainerParts(container, '2');
    if (!parts.quantity) return;

    var current = readQuantity(parts.quantity);
    var total = getTotalQuantity(ol2, '2');
    var next = current + delta;

    if (delta > 0 && (total >= MAX_BOX_TOTAL || current >= MAX_BOX_ITEM)) return;
    if (delta < 0 && current <= 0) return;

    withDomLock(function () {
      writeQuantity(parts.quantity, next);
      updateBoxControls(ol2, { maxTotal: MAX_BOX_TOTAL, maxItem: MAX_BOX_ITEM }, '2');
      updateAtc2SelectionState();
    });
  }

  function addLegacy2FlDynamicBoxToCart(button) {
    if (hasQuantityTabs()) return Promise.resolve();

    var ol2 = document.querySelector('[data-ol-2-fl]');
    if (!ol2 || ol2.closest('[data-quantity-tabs]')) return Promise.resolve();
    if (getTotalQuantity(ol2, '2') < MAX_BOX_TOTAL) return Promise.resolve();

    return fetchSkioDynamicBoxConfig(SKIO_DYNAMIC_BOX_PRODUCT_ID_DAYS).then(function (skioBox) {
      var lineItems = getSelectedFlavorLineItems(ol2, '2', skioBox);
      if (!lineItems.length) return Promise.resolve();

      var totalUnits = 0;
      lineItems.forEach(function (item) {
        totalUnits += item.quantity;
      });
      if (totalUnits < MAX_BOX_TOTAL) return Promise.resolve();

      return addDynamicBoxLineItemsToCart(
        button,
        lineItems,
        LEGACY_BOX_2FL_SELLING_PLAN_ID,
        {
          atcSelector: '[data-atc-2-fl]',
          setAtcDisabledOnStart: true,
          validationConfig: { maxTotal: MAX_BOX_TOTAL, key: '2' },
          context: 'legacy 2-fl box',
          boxProductId: SKIO_DYNAMIC_BOX_PRODUCT_ID_DAYS,
          onFinally: updateAtc2SelectionState,
        }
      );
    });
  }

  function addLegacy1FlDynamicBoxToCart(button) {
    if (hasQuantityTabs()) return Promise.resolve();
    if (!isLegacyOneFlavourBoxActive(button)) return Promise.resolve();

    var variantId = getOneFlavourBoxVariantId(button);
    if (!variantId) return Promise.resolve();

    return addDynamicBoxLineItemsToCart(
      button,
      [{ id: variantId, quantity: 1 }],
      LEGACY_BOX_1FL_SELLING_PLAN_ID,
      {
        atcSelector: '[data-atc-1-fl]',
        validationConfig: { maxTotal: 1, key: '1' },
        context: 'legacy 1-fl box',
        boxProductId: SKIO_DYNAMIC_BOX_PRODUCT_ID_DAYS,
      }
    );
  }

  function initLegacyBoxSelector() {
    if (hasQuantityTabs()) return;

    var ol2 = document.querySelector('[data-ol-2-fl]');
    if (ol2 && !ol2.closest('[data-quantity-tabs]')) {
      withDomLock(function () {
        rememberInitialCaptions(getElements().atc2);

        if (!ol2.dataset.subsQtyInit) {
          ol2.dataset.subsQtyInit = 'true';

          ol2.querySelectorAll('[data-2-fl-container]').forEach(function (container) {
            var parts = getContainerParts(container, '2');
            if (!parts.quantity) return;
            if (!parts.quantity.textContent || !/^\s*\d+\s*$/.test(parts.quantity.textContent)) {
              writeQuantity(parts.quantity, 0);
            }
          });
        }

        updateBoxControls(ol2, { maxTotal: MAX_BOX_TOTAL, maxItem: MAX_BOX_ITEM }, '2');
        updateAtc2SelectionState();
      });
    }

    if (boxSelectorBound) return;
    boxSelectorBound = true;

    document.addEventListener('click', function (event) {
      if (hasQuantityTabs()) return;

      var plus = event.target.closest('[data-plus-2-fl]');
      var minus = event.target.closest('[data-minus-2-fl]');

      if (plus || minus) {
        var ol2Click = event.target.closest('[data-ol-2-fl]');
        if (!ol2Click || ol2Click.closest('[data-quantity-tabs]')) return;

        var container = event.target.closest('[data-2-fl-container]');
        if (!container) return;

        event.preventDefault();
        event.stopPropagation();
        changeLegacyBoxQuantity(container, plus ? 1 : -1);
        return;
      }

      var atc2 = event.target.closest('[data-atc-2-fl]');
      if (!atc2 || atc2.closest('[data-quantity-tabs]')) return;

      var clickTarget = getAtcClickTarget(atc2) || atc2;
      if (
        clickTarget.getAttribute('aria-disabled') === 'true' ||
        clickTarget.disabled ||
        isAddingToCart
      ) {
        return;
      }

      var ol2Atc = document.querySelector('[data-ol-2-fl]');
      if (!ol2Atc || ol2Atc.closest('[data-quantity-tabs]')) return;
      if (getTotalQuantity(ol2Atc, '2') < MAX_BOX_TOTAL) return;

      event.preventDefault();
      event.stopPropagation();
      addLegacy2FlDynamicBoxToCart(clickTarget);
    });
  }

  function bindLegacyResizeSync() {
    if (legacyResizeBound) return;
    legacyResizeBound = true;

    var timer = null;
    window.addEventListener('resize', function () {
      if (hasQuantityTabs()) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        syncLegacyBoxToggle();
      }, 100);
    });
  }

  function initLegacyBoxUi() {
    if (hasQuantityTabs()) return;

    var els = getElements();
    if (!els.toggle && !els.ol2 && !els.atc1.length && !els.atc2.length) return;

    bindLegacyBoxToggle(els.toggle);
    bindLegacyResizeSync();
    syncLegacyBoxToggle();
    bindLegacyAtc1Handler();
    initLegacyBoxSelector();
  }

  function getQuantityTabsAtcButtons() {
    return {
      atcOneTime: document.querySelectorAll('[data-atc-one-time]'),
      atc1: document.querySelectorAll('[data-atc-1-fl]'),
      atc2: document.querySelectorAll('[data-atc-2-fl]'),
      atc3: document.querySelectorAll('[data-atc-3-fl]'),
    };
  }

  function elementContainsMarker(el, selector) {
    if (!el) return false;
    return el.matches(selector) || !!el.querySelector(selector);
  }

  var ONE_TIME_ATC_DEFAULTS = {
    '1': 'Add to cart',
    '2': 'Pick 2 flavours',
    '3': 'Pick 3 flavours',
  };

  var TAB_DISPLAY_PRICES = {
    '1': { subActual: 25, subCompare: 30, oneActual: 30, subServing: 'Only 83p per serving' },
    '2': { subActual: 40, subCompare: 60, oneActual: 60, subServing: 'Only 66p per serving' },
    '3': { subActual: 55, subCompare: 90, oneActual: 90, subServing: 'Only 61p per serving' },
  };

  var TAB_FL_CONFIGS = {
    '2': {
      key: '2',
      panelSelector: '[data-tab-cont-2-fl]',
      tabMarker: '[data-tab-2-fl]',
      atcSelector: '[data-atc-2-fl]',
      maxTotal: 2,
      maxItem: 2,
      qtyInitAttr: 'subsTab2QtyInit',
      observedAttr: 'subsTab2Observed',
    },
    '3': {
      key: '3',
      panelSelector: '[data-tab-cont-3-fl]',
      tabMarker: '[data-tab-3-fl]',
      atcSelector: '[data-atc-3-fl]',
      maxTotal: 3,
      maxItem: 3,
      qtyInitAttr: 'subsTab3QtyInit',
      observedAttr: 'subsTab3Observed',
    },
  };

  function getTabFlConfig(key) {
    return TAB_FL_CONFIGS[key] || null;
  }

  function getActiveQuantityTabKey(quantityTabs) {
    if (!quantityTabs) return null;

    var selectedTab = quantityTabs.querySelector(
      '[role="tab"][aria-selected="true"], button[aria-selected="true"]'
    );
    if (!selectedTab) return null;
    if (elementContainsMarker(selectedTab, '[data-tab-1-fl]')) return '1';
    if (elementContainsMarker(selectedTab, '[data-tab-2-fl]')) return '2';
    if (elementContainsMarker(selectedTab, '[data-tab-3-fl]')) return '3';
    return null;
  }

  function getActiveSubscriptionAtcKey(quantityTabs, subHeader) {
    if (!quantityTabs || !subHeader) return null;
    if (subHeader.getAttribute('aria-expanded') !== 'true') return null;

    return getActiveQuantityTabKey(quantityTabs);
  }

  function getPriceDisplayElement(root) {
    if (!root) return null;
    return root.querySelector('p') || root.querySelector('span') || root;
  }

  function getCurrencyPrefixFromPriceText(text) {
    var match = String(text || '').trim().match(/^([^\d\s]+)/);
    return match ? match[1] : '£';
  }

  function formatTabPrice(amount, templateText) {
    return getCurrencyPrefixFromPriceText(templateText) + amount;
  }

  function setTabPriceOnElement(element, amount) {
    if (!element || amount == null) return;

    var displayEl = getPriceDisplayElement(element);
    if (!displayEl) return;

    var nextText = formatTabPrice(amount, displayEl.textContent);
    if (displayEl.textContent !== nextText) {
      displayEl.textContent = nextText;
    }
  }
  
  function setTabPerServingOnElement(element, amount) {
    if (!element || amount == null) return;

    var displayEl = getPriceDisplayElement(element);
    if (!displayEl) return;

    var nextText = amount;
    if (displayEl.textContent !== nextText) {
      displayEl.textContent = nextText;
    }
  }

  function syncTabDisplayPrices() {
    if (!hasQuantityTabs()) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var tabKey = getActiveQuantityTabKey(quantityTabs);
    var prices = tabKey && TAB_DISPLAY_PRICES[tabKey];
    if (!prices) return;

    document.querySelectorAll('[data-sub-actual-price]').forEach(function (el) {
      setTabPriceOnElement(el, prices.subActual);
    });
    
    document.querySelectorAll('[data-per-serving-cont]').forEach(function (el) {
      setTabPerServingOnElement(el, prices.subServing);
    });

    document.querySelectorAll('[data-sub-compare-price]').forEach(function (el) {
      setTabPriceOnElement(el, prices.subCompare);
    });

    document.querySelectorAll('[data-one-actual-price]').forEach(function (el) {
      setTabPriceOnElement(el, prices.oneActual);
    });
  }

  function syncQuantityTabsAtc() {
    if (!hasQuantityTabs()) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var subHeader = document.querySelector('[data-sub-header]');
    var oneHeader = document.querySelector('[data-one-header]');
    var buttons = getQuantityTabsAtcButtons();
    var oneTimeExpanded =
      oneHeader && oneHeader.getAttribute('aria-expanded') === 'true';
    var activeSubKey = getActiveSubscriptionAtcKey(quantityTabs, subHeader);

    withDomLock(function () {
      setDisplay(buttons.atcOneTime, 'none');
      setDisplay(buttons.atc1, 'none');
      setDisplay(buttons.atc2, 'none');
      setDisplay(buttons.atc3, 'none');

      if (oneTimeExpanded) {
        setDisplay(buttons.atcOneTime, 'flex');
      }

      if (activeSubKey === '1') setDisplay(buttons.atc1, 'flex');
      if (activeSubKey === '2') setDisplay(buttons.atc2, 'flex');
      if (activeSubKey === '3') setDisplay(buttons.atc3, 'flex');

      updateAllTabFlAtcStates();
      updateOneTimeAtcState();
      syncTabDisplayPrices();
      bindIntervalSelect();
    });
  }

  function updateOneTimeAtcState() {
    var atcButtons = document.querySelectorAll('[data-atc-one-time]');
    if (!atcButtons.length) return;

    if (!isOneTimeHeaderExpanded()) {
      atcButtons.forEach(function (atc) {
        setAtcDisabled(atc, true);
      });
      return;
    }

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var tabKey = getActiveQuantityTabKey(quantityTabs);
    var defaultText = (tabKey && ONE_TIME_ATC_DEFAULTS[tabKey]) || '';

    atcButtons.forEach(function (atc) {
      var captionEl = getCaptionParagraph(atc);
      var nextText = defaultText;
      var disabled = true;

      if (tabKey === '1') {
        var panel1 = document.querySelector(TAB1_FL_CONFIG.panelSelector);
        if (panel1 && isTabContFlActive(panel1, TAB1_FL_CONFIG)) {
          nextText = 'Add to cart';
          disabled = !getTab1PanelVariantId(panel1);
        }
      } else if (tabKey === '2' || tabKey === '3') {
        var boxConfig = getTabFlConfig(tabKey);
        var panel = boxConfig ? getTabFlPanel(boxConfig) : null;
        if (panel && isTabContFlActive(panel, boxConfig)) {
          var root = getTabFlRoot(panel, boxConfig);
          var total = getTotalQuantity(root, boxConfig.key);
          nextText = getCaptionTextForBox(total, boxConfig.maxTotal, ONE_TIME_ATC_DEFAULTS[tabKey]);
          disabled = total < boxConfig.maxTotal;
        }
      }

      if (captionEl && captionEl.textContent !== nextText) {
        captionEl.textContent = nextText;
      }

      setAtcDisabled(atc, disabled);
    });
  }

  function observeTab1VariantAttr() {
    var panel = document.querySelector('[data-tab-cont-1-fl]');
    if (!panel || panel.dataset.subsTab1VariantObserved) return;

    panel.dataset.subsTab1VariantObserved = 'true';

    new MutationObserver(function () {
      if (isApplying) return;
      updateOneTimeAtcState();
    }).observe(panel, {
      attributes: true,
      attributeFilter: ['data-tab-cont-1-fl'],
    });
  }

  function bindQuantityTabs() {
    if (quantityTabsBound) {
      bindIntervalSelect();
      syncQuantityTabsAtc();
      syncAllTabFlStates();
      observeTab1VariantAttr();
      return;
    }

    quantityTabsBound = true;
    bindIntervalSelect();
    syncQuantityTabsAtc();

    document.addEventListener(
      'click',
      function (event) {
        if (!hasQuantityTabs()) return;

        var plus = event.target.closest('[data-plus-2-fl], [data-plus-3-fl]');
        var minus = event.target.closest('[data-minus-2-fl], [data-minus-3-fl]');

        if (plus || minus) {
          var qtyContainer = event.target.closest('[data-2-fl-container], [data-3-fl-container]');
          if (!qtyContainer) return;

          var tabContent =
            qtyContainer.closest('[data-tab-cont-2-fl]') ||
            qtyContainer.closest('[data-tab-cont-3-fl]');
          if (!tabContent) return;

          var config = getTabFlConfig(
            qtyContainer.matches('[data-3-fl-container]') ? '3' : '2'
          );
          if (!config || !isTabContFlActive(tabContent, config)) return;
          if (!tabContent.contains(qtyContainer)) return;

          event.stopPropagation();
          changeTabFlQuantity(qtyContainer, plus ? 1 : -1, config);
          return;
        }
      },
      true
    );

    document.addEventListener('click', function (event) {
      if (!hasQuantityTabs()) return;

      var atcOneTime = event.target.closest('[data-atc-one-time]');
      if (atcOneTime) {
        var clickTargetOne = getAtcClickTarget(atcOneTime) || atcOneTime;
        if (
          clickTargetOne.getAttribute('aria-disabled') === 'true' ||
          clickTargetOne.disabled ||
          isAddingToCart
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (isOneTimeHeaderExpanded()) {
          var quantityTabsOne = document.querySelector('[data-quantity-tabs]');
          var oneTimeTabKey = getActiveQuantityTabKey(quantityTabsOne);

          if (oneTimeTabKey && getOneTimeLineItemsForTab(oneTimeTabKey)) {
            event.preventDefault();
            event.stopPropagation();
            addOneTimeToCart(clickTargetOne, oneTimeTabKey);
          }
        }
        return;
      }

      var atc1 = event.target.closest('[data-atc-1-fl]');
      if (atc1) {
        var clickTarget1 = getAtcClickTarget(atc1) || atc1;
        if (
          clickTarget1.getAttribute('aria-disabled') === 'true' ||
          clickTarget1.disabled ||
          isAddingToCart
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var panel1 = document.querySelector(TAB1_FL_CONFIG.panelSelector);
        if (
          panel1 &&
          isTabContFlActive(panel1, TAB1_FL_CONFIG) &&
          getTab1PanelVariantId(panel1) &&
          getIntervalSelectSellingPlanId()
        ) {
          event.preventDefault();
          event.stopPropagation();
          addSubscriptionTabToCart(clickTarget1, '1');
        }
        return;
      }

      var atcFl = event.target.closest('[data-atc-2-fl], [data-atc-3-fl]');
      if (atcFl) {
        var clickTarget = getAtcClickTarget(atcFl) || atcFl;
        if (
          clickTarget.getAttribute('aria-disabled') === 'true' ||
          clickTarget.disabled ||
          isAddingToCart
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var tabKey = atcFl.matches('[data-atc-2-fl]') ? '2' : '3';
        var config = getTabFlConfig(tabKey);
        var panel = config ? getTabFlPanel(config) : null;
        var root = panel ? getTabFlRoot(panel, config) : null;
        if (
          config &&
          panel &&
          isTabContFlActive(panel, config) &&
          root &&
          getTotalQuantity(root, config.key) >= config.maxTotal &&
          getIntervalSelectSellingPlanId()
        ) {
          event.preventDefault();
          event.stopPropagation();
          addSubscriptionTabToCart(clickTarget, tabKey);
        }
        return;
      }

      if (
        event.target.closest('[data-one-header]') ||
        event.target.closest('[data-sub-header]') ||
        event.target.closest('[data-quantity-tabs] [role="tab"]') ||
        event.target.closest('[data-quantity-tabs] button[aria-selected]')
      ) {
        requestAnimationFrame(function () {
          syncQuantityTabsAtc();
          syncAllTabFlStates();
          updateOneTimeAtcState();
          syncTabDisplayPrices();
          syncIntervalForActiveTab();
        });
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        if (!hasQuantityTabs() || !event.isTrusted) return;

        if (
          event.target.closest('[data-tab-1-fl]') ||
          event.target.closest('[data-tab-2-fl]') ||
          event.target.closest('[data-tab-3-fl]') ||
          event.target.closest('[data-quantity-tabs] [role="tab"]')
        ) {
          quantityTabUserChanged = true;
          if (!intervalUserChanged) {
            requestAnimationFrame(syncIntervalForActiveTab);
          }
        }
      },
      true
    );

    new MutationObserver(function (mutations) {
      if (isApplying) return;

      var needsSync = mutations.some(function (mutation) {
        if (mutation.type !== 'attributes') return false;
        if (
          mutation.attributeName !== 'aria-expanded' &&
          mutation.attributeName !== 'aria-selected' &&
          mutation.attributeName !== 'data-state' &&
          mutation.attributeName !== 'data-tab-cont-1-fl'
        ) {
          return false;
        }

        var target = mutation.target;
        if (!target.matches) return false;

        if (
          target.matches('[data-sub-header]') ||
          target.matches('[data-one-header]') ||
          !!target.closest('[data-sub-header]') ||
          !!target.closest('[data-one-header]') ||
          !!target.closest('[data-quantity-tabs]')
        ) {
          return true;
        }

        return false;
      });

      if (needsSync) {
        syncQuantityTabsAtc();
        syncAllTabFlStates();
        syncTabDisplayPrices();
        syncIntervalForActiveTab();
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded', 'aria-selected', 'data-state'],
    });
  }

  function getTabFlPanel(config) {
    return config ? document.querySelector(config.panelSelector) : null;
  }

  function isTabFlTriggerSelected(quantityTabs, config) {
    if (!quantityTabs || !config) return false;

    var selectedTab = quantityTabs.querySelector(
      '[role="tab"][aria-selected="true"], button[aria-selected="true"]'
    );
    return !!(selectedTab && elementContainsMarker(selectedTab, config.tabMarker));
  }

  function getTabFlTabpanel(panel) {
    if (!panel) return null;
    return panel.closest('[role="tabpanel"]') || panel.parentElement;
  }

  function isTabContFlActive(panel, config) {
    if (!panel || !config) return false;

    var tabpanel = getTabFlTabpanel(panel);
    if (!tabpanel || tabpanel.getAttribute('data-state') !== 'active') return false;

    var quantityTabs =
      panel.closest('[data-quantity-tabs]') ||
      document.querySelector('[data-quantity-tabs]');
    if (quantityTabs && !isTabFlTriggerSelected(quantityTabs, config)) return false;

    return true;
  }

  function getTabFlRoot(panel, config) {
    if (!panel || !config) return null;
    return panel.querySelector('[data-ol-' + config.key + '-fl]') || panel;
  }

  function getTabFlLimits(config) {
    return { maxTotal: config.maxTotal, maxItem: config.maxItem };
  }

  function logTabFlSelection(panel, config) {
    var root = getTabFlRoot(panel, config);
    if (!root) return;

    forEachFlContainers(root, config.key, function (container) {
      var parts = getContainerParts(container, config.key);
      var qty = readQuantity(parts.quantity);
      if (qty <= 0) return;

      var optionEl =
        parts.optionEl || container.querySelector(getFlPartSelector(config.key, 'option'));
      var name = getOptionFlName(optionEl, config.key);
      var variantId = name ? getVariantIdByOption(name) : null;

      // console.log('subs.js [tab ' + config.key + '-fl]: выбран вариант', {
      //   id: variantId,
      //   name: name || null,
      //   quantity: qty,
      // });
    });
  }

  function resetTabFlQuantities(panel, config) {
    var root = getTabFlRoot(panel, config);
    if (!root) return;

    withDomLock(function () {
      forEachFlContainers(root, config.key, function (container) {
        var parts = getContainerParts(container, config.key);
        writeQuantity(parts.quantity, 0);
      });
      updateBoxControls(root, getTabFlLimits(config), config.key);
    });
  }

  function initTabFlQuantities(panel, config) {
    var root = getTabFlRoot(panel, config);
    if (!root || panel.dataset[config.qtyInitAttr]) return;

    panel.dataset[config.qtyInitAttr] = 'true';

    forEachFlContainers(root, config.key, function (container) {
      var parts = getContainerParts(container, config.key);
      if (!parts.quantity) return;
      writeQuantity(parts.quantity, readQuantity(parts.quantity));
    });
  }

  function changeTabFlQuantity(container, delta, config) {
    if (!container || !config) return;
    if (!container.matches(getFlContainerSelector(config.key))) return;

    var panel = container.closest(config.panelSelector);
    if (!panel || !isTabContFlActive(panel, config)) return;

    var root = getTabFlRoot(panel, config);
    var parts = getContainerParts(container, config.key);
    if (!root || !parts.quantity) return;

    var limits = getTabFlLimits(config);
    var current = readQuantity(parts.quantity);
    var total = getTotalQuantity(root, config.key);
    var next = current + delta;

    if (delta > 0 && (total >= limits.maxTotal || current >= limits.maxItem)) return;
    if (delta < 0 && current <= 0) return;

    withDomLock(function () {
      writeQuantity(parts.quantity, next);
      updateBoxControls(root, limits, config.key);
      updateTabFlAtcState(config);
      updateOneTimeAtcState();
    });
    logTabFlSelection(panel, config);
  }

  function updateTabFlAtcState(config) {
    if (!config) return;

    var panel = getTabFlPanel(config);
    var atcButtons = document.querySelectorAll(config.atcSelector);
    var total = 0;

    if (panel && isTabContFlActive(panel, config)) {
      total = getTotalQuantity(getTabFlRoot(panel, config), config.key);
    }

    rememberInitialCaptions(atcButtons);

    atcButtons.forEach(function (atc) {
      var captionEl = getCaptionParagraph(atc);
      if (!captionEl) return;

      var initialText = initialCaptions.get(atc) || captionEl.textContent.trim();
      var nextText = getCaptionTextForBox(total, config.maxTotal, initialText);

      if (captionEl.textContent !== nextText) {
        captionEl.textContent = nextText;
      }

      setAtcDisabled(atc, total < config.maxTotal);
    });
  }

  function updateAllTabFlAtcStates() {
    updateTabFlAtcState(TAB_FL_CONFIGS['2']);
    updateTabFlAtcState(TAB_FL_CONFIGS['3']);
    updateOneTimeAtcState();
  }

  function syncTabFlState(config) {
    if (!hasQuantityTabs() || !config) return;

    var panel = getTabFlPanel(config);
    if (!panel) return;

    observeTabFlPanel(panel, config);

    if (!isTabContFlActive(panel, config)) {
      resetTabFlQuantities(panel, config);
      updateTabFlAtcState(config);
      updateOneTimeAtcState();
      return;
    }

    withDomLock(function () {
      initTabFlQuantities(panel, config);
      updateBoxControls(getTabFlRoot(panel, config), getTabFlLimits(config), config.key);
      updateTabFlAtcState(config);
      updateOneTimeAtcState();
    });
  }

  function syncAllTabFlStates() {
    syncTabFlState(TAB_FL_CONFIGS['2']);
    syncTabFlState(TAB_FL_CONFIGS['3']);
  }

  function observeTabFlPanel(panel, config) {
    if (!panel || !config || panel.dataset[config.observedAttr]) return;
    panel.dataset[config.observedAttr] = 'true';

    var tabpanel = getTabFlTabpanel(panel);
    var targets = [panel];
    if (tabpanel) targets.push(tabpanel);

    targets.forEach(function (target) {
      new MutationObserver(function () {
        if (isApplying) return;
        syncTabFlState(config);
      }).observe(target, {
        attributes: true,
        attributeFilter: ['data-state', 'hidden', 'aria-hidden'],
      });
    });
  }

  function bindQuantityTabFl(config) {
    if (!config) return;

    var panel = getTabFlPanel(config);

    if (quantityTabFlBound[config.key]) {
      syncTabFlState(config);
      return;
    }

    quantityTabFlBound[config.key] = true;
    if (panel) observeTabFlPanel(panel, config);
    syncTabFlState(config);
  }

  function initQuantityTabs() {
    if (!hasQuantityTabs()) return;
    bindQuantityTabs();
    bindQuantityTabFl(TAB_FL_CONFIGS['2']);
    bindQuantityTabFl(TAB_FL_CONFIGS['3']);
    observeTab1VariantAttr();
    updateOneTimeAtcState();
    syncTabDisplayPrices();
  }

  function init() {
    if (isApplying) return;

    applyDefaultQuantityTab();
    bindIntervalSelect();

    if (hasQuantityTabs()) {
      initQuantityTabs();
    } else {
      initLegacyBoxUi();
    }

    maybePreloadDynamicBox();
  }

  scheduleInit();
  document.addEventListener('DOMContentLoaded', scheduleInit);
  window.addEventListener('load', scheduleInit);

  document.addEventListener('click', function (event) {
    if (hasQuantityTabs()) return;
    if (!event.target.closest('[data-60-days-2-fl]')) return;
    requestAnimationFrame(syncLegacyBoxToggle);
  });

  new MutationObserver(function (mutations) {
    if (isApplying || hasQuantityTabs()) return;

    var needsInit = mutations.some(mutationIsRelevant);
    if (needsInit) {
      scheduleInit();
      return;
    }

    var affectsToggle = mutations.some(function (mutation) {
      if (mutation.type !== 'attributes') return false;
      var target = mutation.target;
      return (
        target.matches &&
        (target.matches('[data-60-days-2-fl]') ||
          target.matches('[data-one-flavour-box]') ||
          !!target.closest('[data-60-days-2-fl]') ||
          !!target.closest('[data-one-flavour-box]'))
      );
    });

    if (affectsToggle) syncLegacyBoxToggle();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded'],
  });
})();
